import { vservice } from '@niknevis/vue-modules'
import { AdminWalletLogRoute } from '@/modules/wallet-log/routes/admin-wallet-log.route'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'

@vservice()
export class AdminWalletLogService {
  constructor(
    private readonly routes: AdminWalletLogRoute
  ) {
  }

  walletLogs(params: Record<string, string | number | boolean>) {
    return HTTP.get(this.routes.walletLogs(params))
      .then(response => response.json())
  }
}
